import React, { FC, PropsWithChildren, useEffect } from "react";
import { useSheshaApplication } from "@shesha-io/reactjs";
import { formDesignerComponents } from "../designer-components";
import { OrganisationalAccountActionsProvider } from "../components/organisationalAccounts/dynamic-actions";

export interface IAgriErpPluginProps {}

export const AGRI_ERP_PLUGIN_NAME = "Shesha.AgriErp";

export const AgriErpPlugin: FC<PropsWithChildren<IAgriErpPluginProps>> = ({
  children,
}) => {
  const { registerFormDesignerComponents } = useSheshaApplication();

  useEffect(() => {
    registerFormDesignerComponents(
      AGRI_ERP_PLUGIN_NAME,
      formDesignerComponents
    );
  }, []);

  return (
    <OrganisationalAccountActionsProvider>
      {children}
    </OrganisationalAccountActionsProvider>
  );
};
